/* ============================================================================
   is-packaging.js — la scelta del confezionamento (cofanetto, gift pack)

   Stava dentro snippets/is-packaging.liquid, che si rende su ogni pagina del sito
   (vedi il commento in is-cart-blocchi): ~17 KB di JavaScript nell'HTML di ogni
   pagina, mai messi in cache. Qui si scarica una volta e resta.
   Le note di merito sono rimaste in testa allo snippet.
   ========================================================================= */
(function(){
  if (window.__isPackaging) return;
  window.__isPackaging = true;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SOGLIA_INPOST = 4900;
  var MEMORIA_PAIA = 'is-pack-paia';
  var FAMIGLIE = ['barattoli','stirato','extrafine'];

  function euro(c){
    var v = c/100;
    return (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2).replace('.', ',')) + ' €';
  }
  function esc(s){
    return String(s || '').replace(/[&<>"']/g, function(m){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m];
    });
  }
  function nomeBreve(t){
    return String(t || '').replace(/\s*\(per 1 paio di calze\)/i,'').trim();
  }
  function codiceAttivo(cart){
    var testo = JSON.stringify((cart.items || []).map(function(i){ return i.discounts || []; }));
    if (testo.indexOf('PAIO10') > -1) return 'PAIO10';
    if (testo.indexOf('PAIO5') > -1) return 'PAIO5';
    return '';
  }
  function rigaDi(cart, variante){
    return (cart.items || []).filter(function(i){ return i.variant_id === variante; })[0] || null;
  }
  function ricorda(n){ try { sessionStorage.setItem(MEMORIA_PAIA, String(n)); } catch(e){} }
  function ricordato(){ try { return sessionStorage.getItem(MEMORIA_PAIA); } catch(e){ return null; } }

  // una misura (singola o doppia) diventa una riga da mettere in carrello, con dietro il
  // prodotto vero: titolo, foto e prezzo pieno servono al riquadro per mostrarlo
  function voce(conf, quante, misura){
    return { id: conf.id, q: quante, prezzo: conf.prezzo, misura: misura,
             prima: conf.prima, titolo: conf.titolo, img: conf.img };
  }

  // cosa entra in carrello per una tipologia, guardando tutte le famiglie presenti
  function pezziDi(tipologia, fam){
    var pezzi = [];
    FAMIGLIE.forEach(function(nome){
      var gruppo = fam[nome];
      if (!gruppo || !gruppo.paia) return;
      var conf = tipologia.per && tipologia.per[nome];
      if (!conf) return;   // per questa famiglia non serve nulla: e' gia' incluso
      if (conf.doppio && gruppo.coppie > 0) {
        pezzi.push(voce(conf.doppio, gruppo.coppie, 'doppio'));
        if (gruppo.resto > 0 && conf.singolo) {
          pezzi.push(voce(conf.singolo, gruppo.resto, 'singolo'));
        }
      } else if (conf.singolo) {
        pezzi.push(voce(conf.singolo, gruppo.paia, 'singolo'));
      }
    });
    // due famiglie possono volere lo stesso prodotto: si sommano
    var unite = {};
    pezzi.forEach(function(p){
      if (!unite[p.id]) unite[p.id] = { id: p.id, q: 0, prezzo: p.prezzo, misura: p.misura,
                                        prima: p.prima, titolo: p.titolo, img: p.img };
      unite[p.id].q += p.q;
    });
    return Object.keys(unite).map(function(k){ return unite[k]; });
  }
  function spesa(pezzi){
    return pezzi.reduce(function(s, p){ return s + p.prezzo * p.q; }, 0);
  }
  function quantiPezzi(pezzi){
    return pezzi.reduce(function(s, p){ return s + p.q; }, 0);
  }
  // due tipologie diverse possono finire sulle stesse identiche confezioni: la firma serve a
  // riconoscerlo e a mostrarne una sola
  function firmaDi(pezzi){
    return pezzi.map(function(p){ return p.id + 'x' + p.q; }).sort().join('|');
  }

  // dove ci sono paia da appaiare, esiste una confezione che le tiene insieme?
  // Sui barattoli si' (003 e 009), sul cashmere e sullo sport no: li' ogni paio ha il suo.
  function famiglieConDoppia(tipologie, fam){
    var out = {};
    FAMIGLIE.forEach(function(nome){
      var g = fam[nome];
      if (!g || !g.paia || !g.coppie) return;
      out[nome] = (tipologie || []).some(function(t){
        var c = t.per && t.per[nome];
        return !!(c && c.doppio);
      });
    });
    return out;
  }
  // una tipologia si mostra solo se, dove le paia uguali possono stare insieme, le tiene
  // insieme davvero. Due gift pack singoli a 12 € non sono un'alternativa al cofanetto +
  // gift da due paia a 9: sono la stessa cosa fatta peggio e pagata di piu'.
  function tieneInsieme(tip, conDoppia){
    return Object.keys(conDoppia).every(function(nome){
      if (!conDoppia[nome]) return true;
      var c = tip.per && tip.per[nome];
      if (!c) return true;
      return !!c.doppio;
    });
  }

  class Packaging extends HTMLElement {
    connectedCallback(){
      this.codStesse = this.dataset.codiceStesse || '';
      this.codDiverse = this.dataset.codiceDiverse || '';
      if (!this.init()) return;
      Packaging.instances.push(this);
      this.osserva();
      this.aggiorna();
    }
    disconnectedCallback(){
      if (this.mo) { this.mo.disconnect(); this.mo = null; }
      var i = Packaging.instances.indexOf(this);
      if (i > -1) Packaging.instances.splice(i, 1);
    }
    init(){
      try { this.opz = JSON.parse(this.querySelector('.is-pack__dati').textContent) || {}; } catch(e){ this.opz = {}; }
      try { this.t = JSON.parse(this.querySelector('.is-pack__testi').textContent) || {}; } catch(e){ this.t = {}; }
      this.mappa = this.opz.mappa || {};
      this.titoloEl = this.querySelector('[data-pk-titolo]');
      this.opzioniEl = this.querySelector('[data-pk-opzioni]');
      this.notaEl = this.querySelector('[data-pk-nota]');
      return !!(this.opzioniEl && this.titoloEl);
    }
    osserva(){
      var self = this;
      if (this.mo) return;
      this.mo = new MutationObserver(function(){
        if (!self.opzioniEl || !self.contains(self.opzioniEl)) {
          if (self.init()) self.aggiorna();
        }
      });
      this.mo.observe(this, { childList: true, subtree: true });
    }
    aggiorna(){
      var self = this;
      fetch(ROOT + 'cart.js', { headers:{Accept:'application/json'}, credentials:'same-origin' })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(c){
          if (!c) return;
          self.correggiCodice(c);
          if (self.garantisciInclusi(c)) return;
          if (self.adeguaScelta(c)) return;
          self.render(c);
        })
        .catch(function(){});
    }
    correggiCodice(cart){
      var R = window.ISRegolePackaging;
      if (!R) return;
      var s = R.stato(cart, this.mappa);
      if (s.paia < 2) return;
      var voluto = s.stesseIniziali ? this.codStesse : this.codDiverse;
      if (!voluto || codiceAttivo(cart) === voluto) return;
      var chiave = 'is-cod-' + voluto + '-' + s.paia;
      try { if (sessionStorage.getItem(chiave)) return; sessionStorage.setItem(chiave, '1'); } catch(e){}
      R.scrivi('cart/update.js', { discount: voluto })
        .then(function(risp){ if (!R.applica(risp)) window.location.reload(); })
        .catch(function(){});
    }
    // i cofanetti gia' compresi nel prezzo: li mette il carrello, a 0 €, nella misura giusta
    garantisciInclusi(cart){
      var R = window.ISRegolePackaging;
      if (!R || window.__isPackLavoro) return false;
      var inc = this.opz.inclusi || {};
      if (!inc.doppio && !inc.singolo) return false;
      var fam = R.famiglie(cart, this.mappa);
      var attesiDoppi = fam.stirato.paia + fam.extrafine.coppie;
      var attesiSingoli = fam.extrafine.resto;

      var updates = {}, aggiunte = [];
      [[inc.doppio, attesiDoppi], [inc.singolo, attesiSingoli]].forEach(function(coppia){
        var variante = coppia[0], attesi = coppia[1];
        if (!variante) return;
        var riga = rigaDi(cart, variante);
        if (riga && riga.quantity !== attesi) updates[riga.key] = attesi;
        else if (!riga && attesi > 0) aggiunte.push({ id: variante, quantity: attesi });
      });
      if (!Object.keys(updates).length && !aggiunte.length) return false;

      var tentativi = 0;
      try { tentativi = parseInt(sessionStorage.getItem('is-inclusi-tentativi') || '0', 10); } catch(e){}
      if (tentativi > 3) return false;
      try { sessionStorage.setItem('is-inclusi-tentativi', String(tentativi + 1)); } catch(e){}

      window.__isPackLavoro = true;
      var catena = Promise.resolve(null);
      if (Object.keys(updates).length) {
        catena = catena.then(function(){ return R.scrivi('cart/update.js', { updates: updates }); });
      }
      if (aggiunte.length) {
        catena = catena.then(function(){ return R.scrivi('cart/add.js', { items: aggiunte }); });
      }
      catena.then(function(ultima){
        window.__isPackLavoro = false;
        if (!R.applica(ultima)) window.location.reload();
      }).catch(function(){ window.__isPackLavoro = false; });
      return true;
    }
    // quale tipologia e' gia' in carrello
    tipologiaAttiva(cart, fam){
      var tip = this.opz.tipologie || [], trovata = null;
      tip.forEach(function(t){
        if (trovata) return;
        var pezzi = pezziDi(t, fam);
        var dentro = pezzi.some(function(p){ return !!rigaDi(cart, p.id); });
        if (dentro) trovata = t;
      });
      return trovata;
    }
    // se cambiano le paia, la tipologia scelta si riadatta da sola
    adeguaScelta(cart){
      var R = window.ISRegolePackaging;
      if (!R || window.__isPackLavoro) return false;
      var fam = R.famiglie(cart, this.mappa);
      var s = R.stato(cart, this.mappa);
      var attiva = this.tipologiaAttiva(cart, fam);
      if (!attiva) { ricorda(s.paia); return false; }
      if (ricordato() === String(s.paia)) return false;
      ricorda(s.paia);

      var pezzi = pezziDi(attiva, fam);
      var updates = {}, aggiunte = [];
      pezzi.forEach(function(p){
        var riga = rigaDi(cart, p.id);
        if (riga && riga.quantity !== p.q) updates[riga.key] = p.q;
        else if (!riga && p.q > 0) aggiunte.push({ id: p.id, quantity: p.q });
      });
      // le righe di questa tipologia che non servono piu' vanno azzerate
      var voluti = {};
      pezzi.forEach(function(p){ voluti[p.id] = true; });
      (this.opz.tipologie || []).forEach(function(t){
        if (t.chiave !== attiva.chiave) return;
        Object.keys(t.per || {}).forEach(function(fa){
          ['singolo','doppio'].forEach(function(m){
            var c = t.per[fa] && t.per[fa][m];
            if (!c || voluti[c.id]) return;
            var riga = rigaDi(cart, c.id);
            if (riga) updates[riga.key] = 0;
          });
        });
      });
      if (!Object.keys(updates).length && !aggiunte.length) return false;

      window.__isPackLavoro = true;
      var catena = Promise.resolve(null);
      if (Object.keys(updates).length) {
        catena = catena.then(function(){ return R.scrivi('cart/update.js', { updates: updates }); });
      }
      if (aggiunte.length) {
        catena = catena.then(function(){ return R.scrivi('cart/add.js', { items: aggiunte }); });
      }
      catena.then(function(ultima){
        window.__isPackLavoro = false;
        if (!R.applica(ultima)) window.location.reload();
      }).catch(function(){ window.__isPackLavoro = false; });
      return true;
    }
    render(cart){
      if (!this.opzioniEl || !this.contains(this.opzioniEl)) { if (!this.init()) return; }
      var R = window.ISRegolePackaging;
      if (!R) { this.hidden = true; return; }
      var s = R.stato(cart, this.mappa);
      if (!s.paia) { this.hidden = true; return; }
      var fam = s.famiglie;
      var self = this, manca = SOGLIA_INPOST - s.lordo;
      var attiva = this.tipologiaAttiva(cart, fam);

      // la confezione e' stata scelta ed e' in carrello: il riquadro ha finito il suo lavoro
      // e sparisce, cosi' sotto il riepilogo restano solo i totali e il Check-out. Se il
      // cliente cambia idea toglie la riga dal riepilogo col cestino, e il riquadro torna.
      if (attiva) { this.hidden = true; return; }

      var conDoppia = famiglieConDoppia(this.opz.tipologie, fam);
      var firme = {};

      this.titoloEl.innerHTML = this.t.titolo_carrello || this.t.titolo || '';
      this.opzioniEl.innerHTML = '';
      var mostrate = 0;

      (this.opz.tipologie || []).forEach(function(tip){
        var pezzi = pezziDi(tip, fam);
        // una tipologia che non porta niente non si mostra: e' il caso del cofanetto quando
        // in carrello ci sono solo calze che ce l'hanno gia' incluso
        if (!pezzi.length) return;
        // ne' si mostra quella che spezzerebbe in due confezioni un paio di paia uguali
        if (!tieneInsieme(tip, conDoppia)) return;
        // ne' quella che porta le stesse identiche confezioni di una gia' in elenco
        var firma = firmaDi(pezzi);
        if (firme[firma]) return;
        firme[firma] = true;
        mostrate++;

        var costo = spesa(pezzi);
        var quanti = quantiPezzi(pezzi);
        var sbloccaSpedizione = manca > 0 && costo >= manca;

        // se entra un prodotto solo, a schermo si mostra QUEL prodotto: nome, foto e prezzo
        // pieno suoi. Con due paia uguali entra la confezione da due (003, 009).
        var unico = pezzi.length === 1 ? pezzi[0] : null;
        var titolo = (unico && unico.titolo) || tip.titolo;
        var immagine = (unico && unico.img) || tip.img;
        var pieno = unico ? unico.prima : tip.prima;
        var unitario = unico ? unico.prezzo : tip.prezzo;

        // quante confezioni entrano, e come si dice: "2 da due paia" non e' "una per ogni paio"
        var nota = '';
        if (quanti > 1) {
          var doppie = pezzi.filter(function(p){ return p.misura === 'doppio'; });
          var singole = pezzi.filter(function(p){ return p.misura === 'singolo'; });
          var quanteDoppie = doppie.reduce(function(n, p){ return n + p.q; }, 0);
          if (quanteDoppie && singole.length) {
            nota = String(self.t.coppie || '').replace('%n%', quanteDoppie) +
                   ' ' + (self.t.piu_singolo || '');
          } else if (quanteDoppie) {
            nota = String(self.t.coppie || '').replace('%n%', quanteDoppie);
          } else {
            nota = String(self.t.per_paio || '').replace('%n%', quanti);
          }
        }

        var barrato = (pieno && pieno > unitario)
          ? '<span class="is-pack__prima">' + euro(pieno) + '</span>' : '';
        // confezioni tutte uguali: si scrive quanto costa UNA, con "cad." sotto.
        // Confezioni diverse: il totale, perche' un unitario non direbbe nulla.
        var prezzo;
        if (unico && quanti > 1) {
          prezzo = barrato + euro(unico.prezzo) +
                   '<span class="is-pack__cad">' + esc(self.t.cad || 'cad.') + '</span>';
        } else if (quanti === 1) {
          prezzo = barrato + euro(costo);
        } else {
          prezzo = euro(costo);
        }

        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'is-pack__riga';
        b.setAttribute('aria-pressed', 'false');
        b.innerHTML =
          '<span class="is-pack__segno"></span>' +
          (immagine ? '<img class="is-pack__img" src="' + esc(immagine) + '" alt="" loading="lazy" decoding="async">' : '') +
          '<span class="is-pack__testo">' +
            '<span class="is-pack__nome">' + esc(nomeBreve(titolo)) + '</span>' +
            (nota ? '<span class="is-pack__quanti">' + esc(nota) + '</span>' : '') +
            (sbloccaSpedizione ? '<span class="is-pack__spedizione">' + (self.t.spedizione || '') + '</span>' : '') +
          '</span>' +
          '<span class="is-pack__prezzo">' + prezzo + '</span>';
        b.addEventListener('click', function(){
          Array.prototype.forEach.call(self.opzioniEl.children, function(x){ x.classList.remove('is-scelta'); });
          b.classList.add('is-scelta');
          self.scegli(tip, pezzi, cart, fam, s.paia, false);
        });
        self.opzioniEl.appendChild(b);
      });

      this.notaEl.hidden = true;
      this.hidden = mostrate === 0;
    }
    // un clic mette la tipologia su tutte le paia e toglie le altre
    scegli(tip, pezzi, cart, fam, paia, giaScelta){
      var self = this, R = window.ISRegolePackaging;
      Array.prototype.forEach.call(this.opzioniEl.children, function(x){ x.disabled = true; });
      this.notaEl.hidden = false;
      this.notaEl.textContent = this.t.corso || '...';
      ricorda(paia);

      // si azzera tutto quello che le tipologie possono aver messo in carrello
      var azzera = {};
      (this.opz.tipologie || []).forEach(function(t){
        Object.keys(t.per || {}).forEach(function(fa){
          ['singolo','doppio'].forEach(function(m){
            var c = t.per[fa] && t.per[fa][m];
            if (!c) return;
            var riga = rigaDi(cart, c.id);
            if (riga) azzera[riga.key] = 0;
          });
        });
      });

      window.__isPackLavoro = true;
      var catena = Promise.resolve(null);
      if (Object.keys(azzera).length) {
        catena = catena.then(function(){ return R.scrivi('cart/update.js', { updates: azzera }); });
      }
      if (!giaScelta) {
        var items = pezzi.map(function(p){ return { id: p.id, quantity: p.q }; });
        catena = catena.then(function(){ return R.scrivi('cart/add.js', { items: items }); });
      }
      catena.then(function(ultima){
        window.__isPackLavoro = false;
        if (!R.applica(ultima)) window.location.reload();
      }).catch(function(){
        window.__isPackLavoro = false;
        Array.prototype.forEach.call(self.opzioniEl.children, function(x){ x.disabled = false; });
        self.notaEl.textContent = self.t.errore || 'Riprova';
      });
    }
    static refresh(){
      Packaging.instances.forEach(function(p){ p.aggiorna(); });
    }
  }
  Packaging.instances = [];
  if (!customElements.get('is-packaging')) customElements.define('is-packaging', Packaging);

  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  var t = null;
  function soon(){
    clearTimeout(t);
    t = setTimeout(function(){ Packaging.refresh(); }, 250);
  }
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function(input){
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = _fetch.apply(this, arguments);
      if (CART_WRITE.test(url)) p.then(soon).catch(function(){});
      return p;
    };
  }
  ['cart:updated','cart:refresh','cart:change','cart:update','cart-drawer:open'].forEach(function(e){
    document.addEventListener(e, soon);
  });
  document.addEventListener('shopify:section:load', soon);
  window.addEventListener('pageshow', soon);
})();
